import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import axios from "axios";
import "./../style.css";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import trueimages from "./../Asset/true-images.png";
import failimages from "./../Asset/fail-images.png";
import warningimages from "./../Asset/warning-icon.png";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Select from 'react-select';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import RunReportNow from "../RunReportNow";
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import { useNavigate } from "react-router-dom";
import Loader from "../CommonLoader";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import { datezonechange } from "./../Commonfun";
import CommonAlert from "../../../Commonalert/commonalert";
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import rankedkeywordsicon from "../Asset/ESO/rankedkeywords.png";
import RankedKeywordssvg from "../Asset/esocardicon/FileAccessibilityReport/Score.svg";
import { useMediaQuery } from "react-responsive";
import DatagridComp from "../DatagridComp";
import PdfandCsv from "../PdfandCsv";
import Commoncard from "../Commoncard";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import UserActivityTracker from "../../../hooks/userActivityTracker";
import Invalid_Linkssvg from "../Asset/esocardicon/ExternalLinks/Invalid_Links.svg"
import VideoLinkssvg from "../Asset/esocardicon/ExternalLinks/VideoLinks.svg"
import TotalExternalLinkssvg from "../Asset/esocardicon/ExternalLinks/TotalExternalLinks.svg"
import RootDomainsLinkedsvg from "../Asset/esocardicon/ExternalLinks/RootDomainsLinked.svg"
import totalpagessvg from "../Asset/esocardicon/aiready/totalpages.svg"
import readypagessvg from "../Asset/esocardicon/aiready/readypages.svg"
import needattentionsvg from "../Asset/esocardicon/aiready/needattention.svg"
import { Breadcrumbs, Typography } from "@mui/material";
import Chart from "react-apexcharts";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Chip,
  Paper,
  Card,
  CardContent,
} from "@mui/material";


export default function AiReadiness({ reportStatus = false, instantReport = "" }) {

  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState("");
  const esodata = useSelector((state) => state);
  const [SectionOptions, SetSectionOptions] = useState([]);
  const [DoaminSectionUrl, SetDoaminSectionUrl] = useState([])
  const [Domainsectiondata, SetDomainsectiondata] = useState([])
  const ApiToken = esodata.apiauthkey.value
  const [autoheightval, SetAutoheightval] = useState(true)
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [initialDateval, SetInitialDateval] = useState([]);
  const [fataloutCount, setfataloutCount] = useState();
  const [performancePlan, setperformancePlan] = useState({ status: true, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [first, setfirst] = useState({ name: "", path: "", closeName: "Close", statusDomain: false });
  const [checkD, setcheckD] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [healthdata, setHealthdata] = useState([]);

  const [total_pages, SetTotal_pages] = useState(0)
  const [ready_pages, SetReady_pages] = useState(0)
  const [needs_attention, SetNeeds_attention] = useState(0)
  const [critical_issues, SetCritical_issues] = useState(0)
  const [overall_score, SetOverall_score] = useState(0)
  const [externallinkcount, setExternallinkcount] = useState([]);
  const [categorystatus, setCategorystatus] = useState([]);
  const [typedata, setTypedata] = useState([]);
  const [distributionCount, setDistributionCount] = useState([]);
  const [visibleCount, setVisibleCount] = useState(3);
  const donutChartLabel = ['Crawlability', 'Semantic Structure', 'Content Clarity', 'Structured Data', 'Page Rendering', 'Authority Context'];
  const distributionlabel = ['0-29', '30-49', '50-69', '70-89', '90-100'];
  const [aiissues, setAiissues] = useState([]);
  const visibleItems = typedata.slice(0, visibleCount);
  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });


  let detailurl = `${process.env.REACT_APP_DOMAIN}ai-readiness-detail/`;

  useEffect(() => {
    const handleScroll = () => {
      if (
        window.innerHeight + document.documentElement.scrollTop + 1 >=
        document.documentElement.scrollHeight
      ) {
        setVisibleCount(prev => prev + 1);
      }
    };
  });
  const checkUserPlan = async () => {
    const performanceP = await Utils("ai_readiness_report", ApiToken);
    if (performanceP.status) {
      callUserdataApi();
      LoadAddFormFilterOptions();
      faqdatafun();
    }
    setperformancePlan(performanceP);
  };

  useEffect(() => {
    checkUserPlan();
    GetuserDatavalue();
  }, []);

  const GetuserDatavalue = async () => {
    try {
      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {

        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          navigate('/errorpages');
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages');
        }
      });
      if (datavalue?.data) {
        if (datavalue?.data?.is_location_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Userdata", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Impadddomain", statusDomain: true });
          return
        }
        if (datavalue?.data?.is_domain_ownership_required === true) {
          setfirst({ ...first, name: "Verify Now", path: "/Domainownership", statusDomain: true });
          return
        }

      }

    } catch (err) {
      console.log(err);
    }
  };


  const columns = [


    {
      field: "url",
      headerName: "URL",
      description: 'The URL of the web page to monitor usability, accessibility, UX, and performance under URL management settings.',
      minWidth: 320,
      flex: 1,
      sortable: true,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {

        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        return (
          <>
            <Tooltip title={cardData.row.url}>
              <div className="prefered_url_external02">
                <a
                  target="_blank"
                  href={cardData?.row?.url}
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <span className="spanlink">
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span
                    className="spanlink"
                    style={{
                      color: "#044792",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                    }}
                  >
                    {remaining}
                  </span>
                </a>
              </div>
            </Tooltip>
          </>
        );

      },
    },
    {
      field: "crawlability",
      headerName: "Crawlability",
      description: 'UX score for the specific URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        if (cardData.row.crawlability == "Good") {
          return <img src={trueimages} className="view_per_img" alt="Good" />;
        } else if (cardData.row.crawlability == "Fair") {
          return <img src={warningimages} className="view_per_img" alt="Warning" />;
        } else {
          return <img src={failimages} className="view_per_img" alt="Fail" />;
        }
      }
    },
    {
      field: "semantic_structure",
      headerName: "Semantic Structure",
      description: 'SEO Impact on the specific URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        if (cardData.row.semantic_structure == "Good") {
          return <img src={trueimages} className="view_per_img" alt="Good" />;
        } else if (cardData.row.semantic_structure == "Fair") {
          return <img src={warningimages} className="view_per_img" alt="Warning" />;
        } else {
          return <img src={failimages} className="view_per_img" alt="Fail" />;
        }
      }
    },
    {
      field: "content_clarity",
      headerName: "Content Clarity",
      description: 'Responsiveness of the URL or web page',
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        if (cardData.row.content_clarity == "Good") {
          return <img src={trueimages} className="view_per_img" alt="Good" />;
        } else if (cardData.row.content_clarity == "Fair") {
          return <img src={warningimages} className="view_per_img" alt="Warning" />;
        } else {
          return <img src={failimages} className="view_per_img" alt="Fail" />;
        }
      }
    },
    {
      field: "structured_data",
      headerName: "Structured Data",
      description: 'Responsiveness of the URL or web page',
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        if (cardData.row.structured_data == "Good") {
          return <img src={trueimages} className="view_per_img" alt="Good" />;
        } else if (cardData.row.structured_data == "Fair") {
          return <img src={warningimages} className="view_per_img" alt="Warning" />;
        } else {
          return <img src={failimages} className="view_per_img" alt="Fail" />;
        }
      }
    },
    {
      field: "page_rendering",
      headerName: "Page Rendering",
      description: 'Responsiveness of the URL or web page',
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        if (cardData.row.page_rendering == "Good") {
          return <img src={trueimages} className="view_per_img" alt="Good" />;
        } else if (cardData.row.page_rendering == "Fair") {
          return <img src={warningimages} className="view_per_img" alt="Warning" />;
        } else {
          return <img src={failimages} className="view_per_img" alt="Fail" />;
        }
      }
    },
    {
      field: "authority_context",
      headerName: "Authority Context",
      description: 'UX score for the specific URL or web page',
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (cardData) => {
        if (cardData.row.authority_context == "Good") {
          return <img src={trueimages} className="view_per_img" alt="Good" />;
        } else if (cardData.row.authority_context == "Fair") {
          return <img src={warningimages} className="view_per_img" alt="Warning" />;
        } else {
          return <img src={failimages} className="view_per_img" alt="Fail" />;
        }
      }
    },
    {
      field: "View",
      headerName: "View",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      headerClassName: "hide_option",
      renderCell: (cardData) => {
        return (
          <a href={detailurl + `${cardData.row.id}`}>
            <button className="view-report-button">
              View Report
            </button>
          </a>
        );
      },
    },

  ]

  const issues = {
    authority_context: { poor: 0, fair: 62 },
    content_clarity: { poor: 0, fair: 63 },
    crawlability: { poor: 0, fair: 0 },
    page_rendering: { poor: 0, fair: 63 },
    semantic_structure: { poor: 0, fair: 63 },
    structured_data: { poor: 0, fair: 5 },
  };


  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "", domainsecdata = "", pageNumber = 1, rowsPerPage = 10) => {
    // if (domainsecdata == "")
    //   domainsecdata = Domainsectiondata;
    if (jobid == "")
      jobid = jobidData;
    setLoading(true);
    setTableLoading(true);
    setCardData([])
    try {


      const datavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}customized_report/ai_readiness_report/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      ).catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });
      if (datavalue?.data?.job_date)
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"))
      else
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY"))
      if (datavalue?.data?.result) {
        const dataval = datavalue.data.result;

        var newData = "";
        if (dataval && dataval.length > 0) {
          SetAutoheightval(false)
          const newData = dataval.map((obj, index) => {
            return { ...obj, sid: index + 1 };
          });
          console.log("newData", datavalue.data)
          setAiissues(datavalue?.data?.issues || [])
          setTypedata(datavalue?.data?.insights)
          setDistributionCount(datavalue?.data?.score_distribution)
          setCategorystatus(datavalue.data?.category_status)
          setExternallinkcount(datavalue.data?.category_performance)
          SetTotal_pages(datavalue?.data?.kpis?.total_pages)
          SetReady_pages(datavalue?.data?.kpis?.ready_pages)
          SetNeeds_attention(datavalue?.data?.kpis?.needs_attention)
          SetCritical_issues(datavalue?.data?.kpis?.critical_issues)
          SetOverall_score(datavalue?.data?.kpis?.overall_score)
          setHealthdata(datavalue?.data?.health || []);
          setCardData(newData);
        }
        else {
          setCardData("");
          SetAutoheightval(true)
        }
      }
    }
    catch (err) {
      console.log('err', err)
    }
    setTableLoading(false);
    setLoading(false);

  };
  function openModal() {
    if (performancePlan.status) {
      setIsOpen(true);
    }
  }
  function closeModal() {
    setSelectval("");
    setIsOpen(false);
    SetdEngineoption(prevdEngineoption);
  }

  const formatLabel = (key) => {
    return key
      .replaceAll("_", " ")
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const categories = Object.keys(aiissues).map(formatLabel);

  const poorData = Object.values(aiissues).map((item) => item.poor);

  const fairData = Object.values(aiissues).map((item) => item.fair);

  const [RunReportPopShow, SetRunReportPopShow] = useState(false)
  const [RunReportType, SetRunReportType] = useState('ai_readiness')
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });
  const dataseries = [
    {
      name: "Poor",
      data: poorData || [],
    },
    {
      name: "Fair",
      data: fairData || [],
    },
  ];
  const cardDatas = [
    {

      value: total_pages || 0,
      title: "Total Pages",
      badge: "TOTAL PAGES",
      iconSrc: totalpagessvg,
      iconColor: 1,
      bgColor: 1,

    },
    {

      value: ready_pages || 0,
      title: "Ready Pages",
      badge: "READY PAGES",
      iconSrc: readypagessvg,
      iconColor: 2,
      bgColor: 2,

    },
    {

      value: needs_attention || 0,
      title: "Needs Attention",
      badge: "ATTENTION",
      iconSrc: needattentionsvg,
      iconColor: 3,
      bgColor: 3,

    },
    {

      value: critical_issues || 0,
      title: "Critical Issues",
      badge: "ISSUES",
      iconSrc: Invalid_Linkssvg,
      iconColor: 4,
      bgColor: 4,

    }

  ];
  const [prevdEngineoption, setprevdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });

  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}customized_report/ai_readiness_report/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&timezone=${timezoneval()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/pdf',
            Authorization: `${ApiToken}`,
          },
        });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("aireadiness", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const dataoptions = {
    chart: {
      type: "bar",
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        borderRadius: 6,
      },
    },

    dataLabels: {
      enabled: false,
    },

    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    colors: ["#EF4444", "#F59E0B"],

    xaxis: {
      categories,
      labels: {
        style: {
          fontSize: "12px",
        },
        formatter: function (value) {
          return String(value || "").substring(0, 10).toUpperCase();
        },
        offsetX: 80
      },


    },

    yaxis: {
      title: {
        text: "Issues Count",
      },
    },

    fill: {
      opacity: 1,
    },

    legend: {
      position: "top",
      fontSize: "13px",
    },

    grid: {
      borderColor: "#E2E8F0",
    },

    tooltip: {
      y: {
        formatter: function (val) {
          return `${val} issues`;
        },
      },
    },
  };

  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}customized_report/ai_readiness_report/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("aireadiness", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const LoadAddFormFilterOptions = async () => {
    SetSectionOptions([]);
    try {
      const doaminsectiondatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_domain_sections/?user_domain_id=${esodata.domaindata.value.header_selected}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        if (doaminsectiondatavalue?.data?.domain_sections) {

          SetDoaminSectionUrl(doaminsectiondatavalue?.data?.domain_sections)
          var Sections = [];
          doaminsectiondatavalue.data.domain_sections.forEach((element) => {
            Sections.push({ label: element.name, value: element.id });
          });
          SetSectionOptions(Sections);
        }
      }
    } catch (err) { }
  }
  const SetSectionNameHandle = (passvalue) => {
    if (passvalue) {
      SetDomainsectiondata(passvalue.value)
      callUserdataApi("", passvalue.value);
    } else {
      SetDomainsectiondata("")
      callUserdataApi();
    }
  }

  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=80`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  function handleReset() {
    SetdEngineoption("");
    setSelectval("");
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }

  const getPagination = (pageNumber = 1, rowsPerPage = 10) => {
    callUserdataApi("", Domainsectiondata, pageNumber, rowsPerPage);
  }

  const statusStyles = {
    good: {
      label: "Good",
      color: "#10B981",
      bg: "#D1FAE5",
    },
    needs_improvement: {
      label: "Needs Improvement",
      color: "#F59E0B",
      bg: "#FEF3C7",
    },
    critical: {
      label: "Critical",
      color: "#EF4444",
      bg: "#FEE2E2",
    },
  };


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>

      {loading === true ? <Loader /> : null}

      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Ai Readiness </title>
      </Helmet>
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <div className="">

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={4}>
                <div>
                  <h1 className="dashboard_header">
                    Ai Readiness
                    <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                  </h1>
                </div>
              </Grid>
              <Grid item xs={12} md={8}>
                <div className="top_breadcrumb_menu">
                  <div className="exportpdf_outer">
                    <div className="breadcrumb-wrapper">
                      <CommonBreadCrumb breadcrumbValue={[
                        { title: 'AI Readiness', activeColor: true }
                      ]} />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-time">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={6}>
                <div className="time_zone">
                  <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                  <span className="timezone-val">{timezoneval()}</span>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="drop_down_button" >
                  <button
                    title="Run Report"
                    className="btn_dashboard"
                    onClick={() => {
                      if (first.statusDomain) {
                        setcheckD(first.statusDomain);
                      } else {
                        SetRunReportPopShow(true);
                      }
                    }}
                    disabled={!performancePlan.status}
                  >
                    Run Report Now
                  </button>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>
        <Container maxWidth={false} className="dashboard-card-container">
          <Box >
            <Grid container className="dashboard-box-card">
              <Grid container spacing={3} justifyContent="center">
                {cardDatas.map((item, index) => (
                  <Grid item xs={12} sm={6} md={3} key={item.id}>
                    <Commoncard
                      item={item}
                      nonclikable={true}
                    />
                  </Grid>
                ))}

              </Grid>

            </Grid>
          </Box>
        </Container>
        <Container maxWidth={false} className="dashboard-container">
          <Grid container spacing={2} style={{ marginBottom: '20px' }}>
            <Grid item xs={12} md={4}>
              <Box
                className="grid_table_shodow"
                style={{
                  height: "310px",
                  padding: "10px"
                }}
              >
                <Typography
                  variant="h6"
                  style={{
                    color: "#000",
                    fontWeight: "bold",
                    textAlign: "center"
                  }}
                >
                  Health Score ( Grade - {healthdata?.grade} )
                </Typography>

                {(() => {
                  const status = healthdata?.status
                    ?.toLowerCase()
                    ?.replaceAll("_", " ");

                  const statusConfig = {
                    excellent: {
                      color: "#22c55e",
                      label: "Excellent"
                    },
                    good: {
                      color: "#3b82f6",
                      label: "Good"
                    },
                    "need improvement": {
                      color: "#f59e0b",
                      label: "Need Improvement"
                    },
                    "needs improvement": {
                      color: "#f59e0b",
                      label: "Need Improvement"
                    },
                    critical: {
                      color: "#ef4444",
                      label: "Critical"
                    }
                  };

                  const currentStatus = statusConfig[status] || {
                    color: "#999",
                    label: "Unknown"
                  };

                  return (
                    <>
                      <Chart
                        type="radialBar"
                        height={240}
                        series={[healthdata?.score || 0]}
                        options={{
                          colors: [currentStatus.color],
                          chart: {
                            sparkline: {
                              enabled: true
                            }
                          },
                          plotOptions: {
                            radialBar: {
                              hollow: {
                                size: "70%"
                              },
                              track: {
                                background: "#f2f2f2"
                              },
                              dataLabels: {
                                name: {
                                  show: false
                                },
                                value: {
                                  fontSize: "28px",
                                  fontWeight: "bold",
                                  color: currentStatus.color,
                                  offsetY: 10,
                                  formatter: function (val) {
                                    return Number(val);
                                  }
                                }
                              }
                            }
                          },
                          stroke: {
                            lineCap: "round"
                          }
                        }}
                      />

                      {/* Status Text */}
                      <Typography
                        variant="h6"
                        style={{
                          textAlign: "center",
                          marginTop: "-15px",
                          fontWeight: "bold",
                          color: currentStatus.color
                        }}
                      >
                        {currentStatus.label}
                      </Typography>
                    </>
                  );
                })()}
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Category Performance</Typography>
                <Chart
                  type="donut"
                  height={240}
                  series={[
                    externallinkcount?.crawlability || 0,
                    externallinkcount?.semantic_structure || 0,
                    externallinkcount?.content_clarity || 0,
                    externallinkcount?.structured_data || 0,
                    externallinkcount?.page_rendering || 0,
                    externallinkcount?.authority_context || 0
                  ]}
                  options={{
                    labels: donutChartLabel,
                    colors: [
                      '#2e7d32',
                      '#4caf50',
                      '#ffb74d',
                      '#ffeb3b',
                      '#fb8c00',
                      '#b71c1c'
                    ],
                    legend: {
                      position: 'bottom',
                      fontSize: '10px'
                    },
                    dataLabels: {
                      enabled: false
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  background: "#fff",
                  borderRadius: "18px",
                  padding: "16px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                  height: "300px",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: 700,
                    color: "#1E293B",
                    mb: 2,
                    justifyContent: "center"
                  }}
                >
                  Category Status
                </Typography>

                {/* Scrollable Table */}
                <TableContainer
                  component={Paper}
                  elevation={0}
                  sx={{
                    maxHeight: 320,
                    overflowY: "auto",

                    /* Optional custom scrollbar */
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#CBD5E1",
                      borderRadius: "10px",
                    },
                  }}
                >
                  <Table stickyHeader>
                    <TableBody>
                      {Object.entries(categorystatus).map(([key, value]) => {
                        const status = statusStyles[value];

                        return (
                          <TableRow
                            key={key}
                            sx={{
                              "&:last-child td": {
                                borderBottom: 0,
                              },
                            }}
                          >
                            <TableCell
                              sx={{
                                fontWeight: 600,
                                color: "#334155",
                                borderBottom: "1px solid #F1F5F9",
                              }}
                            >
                              {formatLabel(key)}
                            </TableCell>

                            <TableCell
                              align="right"
                              sx={{
                                borderBottom: "1px solid #F1F5F9",
                              }}
                            >
                              <Chip
                                label={status.label}
                                sx={{
                                  background: status.bg,
                                  color: status.color,
                                  fontWeight: 700,
                                  borderRadius: "30px",
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

          </Grid>
        </Container>
        <Container maxWidth={false} className="dashboard-container">
          <Grid container spacing={2} style={{ marginBottom: '20px' }}>
            <Grid item xs={12} md={4}>
              <Box className="grid_table_shodow" style={{ padding: '15px', height: '300px' }}>
                <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: '10px' }}>Score Distribution</Typography>
                <Chart
                  type="bar"
                  height={250}
                  series={[
                    {
                      name: 'Count',
                      data: [
                        distributionCount?.['0-29'] || 0,
                        distributionCount?.['30-49'] || 0,
                        distributionCount?.['50-69'] || 0,
                        distributionCount?.['70-89'] || 0,
                        distributionCount?.['90-100'] || 0
                      ]
                    }
                  ]}
                  options={{
                    chart: {
                      toolbar: {
                        show: false
                      }
                    },
                    plotOptions: {
                      bar: {
                        horizontal: true,
                        borderRadius: 4,
                        barHeight: '45%'
                      }
                    },
                    colors: ['#1976d2'],
                    dataLabels: {
                      enabled: true
                    },
                    xaxis: {
                      categories: distributionlabel,
                      labels: {
                        // rotate: -45,
                        offsetX: -150
                      }
                    },
                    grid: {
                      borderColor: '#e0e0e0'
                    },
                    tooltip: {
                      y: {
                        formatter: value => `${value} `
                      }
                    }
                  }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                sx={{
                  background: "#fff",
                  borderRadius: "18px",
                  padding: "15px",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.06)",
                  height: '300px',
                }}
              >
                <Typography
                  sx={{
                    fontSize: "18px",
                    fontWeight: 700,
                    color: "#1E293B",
                    mb: 2,
                  }}
                >
                  Issues Comparison
                </Typography>

                <Chart
                  options={dataoptions}
                  series={dataseries}
                  type="bar"
                  height={250}
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box
                className="grid_table_shodow"
                style={{
                  padding: '12px',
                  height: '310px',
                  overflowY: 'auto'
                }}
              >
                <Typography
                  variant="subtitle1"
                  style={{
                    fontWeight: 600,
                    marginBottom: '12px'
                  }}
                >
                  Insights
                </Typography>

                {visibleItems.map((item, index) => {
                  const typeStyles = {
                    critical: {
                      border: '#e53935',
                      bg: '#ffebee',
                      color: '#c62828'
                    },
                    warning: {
                      border: '#fb8c00',
                      bg: '#fff3e0',
                      color: '#ef6c00'
                    },
                    improvement: {
                      border: '#43a047',
                      bg: '#e8f5e9',
                      color: '#2e7d32'
                    }
                  };

                  const current = typeStyles[item.type];

                  return (
                    <Card
                      key={index}
                      style={{
                        marginBottom: '10px',
                        borderLeft: `4px solid ${current.border}`,
                        borderRadius: '10px',
                        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
                      }}
                    >
                      <CardContent style={{ padding: '12px' }}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="flex-start"
                          gap={1}
                        >
                          <Box>
                            <Typography
                              variant="body2"
                              style={{
                                fontWeight: 600,
                                marginBottom: '4px',
                                lineHeight: 1.4
                              }}
                            >
                              {item.message}
                            </Typography>

                            <Typography
                              variant="caption"
                              style={{
                                color: '#666',
                                lineHeight: 1.5
                              }}
                            >
                              {item.action}
                            </Typography>
                          </Box>

                          <Chip
                            label={item.type}
                            size="small"
                            style={{
                              background: current.bg,
                              color: current.color,
                              fontWeight: 600,
                              textTransform: 'capitalize',
                              fontSize: '11px'
                            }}
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  );
                })}
              </Box>
            </Grid>

          </Grid>
        </Container>
        <Container maxWidth={false} className="dashboard-container">
          <Box className="grid_table_shodow">
            <Grid container className="dashboard-grid">
              <Grid item xs={12} md={12}>
                <div className="cnt_audit_outer_wrap">
                  {performancePlan.status ?
                    <div>

                      <DatagridComp
                        columns={columns}
                        rows={rows}
                        autoheightval={autoheightval}
                        datagridval={2}
                        columnFreezeWidth={[0, 320]}
                        tableLoading={tableLoading}
                        handleModelPopUp={handleModelPopUp}
                        handleDownlodingCSV={handleDownlodingCSV}
                        handleDownlodingPDF={handleDownlodingPDF}
                        DownloadShowFile={true}
                        DownloadShowPDF={1}
                        DownloadShowCSV={2}
                      // paginationData={getPagination}
                      />
                    </div> : <Freeaudit planStatus={performancePlan} />
                  }
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        <Container maxWidth={false} className="footer-container">
          <Box className="footer-box">
            <Grid container className="footer-grid">
              <Grid item xs={12} md={6}>
                <div className="footer-left">
                  <p className="footer-text">
                    All Rights Reserved Copyright © 2026 |
                    <a href="https://www.egrovesys.com/" target="blank">
                      <span className="footer-brand"> Elite site Optimizer</span>
                    </a>
                  </p>
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div className="footer-right">
                  <p>{/* Add content if needed */}</p>
                </div>
              </Grid>
            </Grid>
          </Box>
        </Container>

        {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

      </div>
      <Dialog
        open={modalIsOpen}
        onClose={closeModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="competitor_test_filter job_date_filter"
      >
        <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="cnt_hdr_blw_wrap row">

              <div>

                <div className="">
                  <div>
                    <span>Completed Date</span>
                    <Select
                      value={dEngineoption}
                      options={completedate}
                      placeholder="Select..."
                      labelField="completed_at"
                      valueField="id"
                      onChange={(values) => {
                        setSelectval(values)
                        SetdEngineoption(values);
                        setValidation({
                          dateerror: "",
                        })
                      }}
                      styles={customDropdownStyles()}
                      menuPortalTarget={document.body}
                    />
                  </div>


                </div>
                <span className="text-error">{validation.dateerror}</span>
              </div>

            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">

          <button style={{ cursor: 'pointer' }} onClick={closeModal}>close</button>
          <button style={{ cursor: 'pointer' }} onClick={handleReset}>Reset</button>
          {/* <button
            className="form_submit_btn"
            style={{ cursor: "pointer" }}
            onClick={handleReset}
          >
            Reset
          </button> */}
        </DialogActions>
      </Dialog>

      {!openCommonAlerts &&
        <>
          <CommonErrorAlert
            data={{
              apiopen: open,
              apiErrorMsg: 'No Data Found',
              isIconStyled: true
            }}
            closeAlert={handleClose} />
          <CommonErrorAlert
            data={{
              apiopen: apiopen,
              apiErrorMsg: apierrorMsg,
              isIconStyled: true
            }}
            closeAlert={apihandleClose} />
        </>
      }
      <Dialog
        open={checkD}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="domain-verify-alert"
      >
        <DialogTitle className="keyword-dialog-header">Alert</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Please verify your domain to access these features
          </DialogContentText>
        </DialogContent>
        <DialogActions className="dialog-action-button">
          <Button onClick={() => { navigate(first.path) }} >{first.name}</Button>
          <Button onClick={() => setcheckD(false)} >{first.closeName}</Button>
        </DialogActions>
      </Dialog>
      <RunReportNow
        RunReportPopShow={RunReportPopShow}
        SetRunReportPopShow={SetRunReportPopShow}
        RunReportType={RunReportType}
        isDomainSection={true}
      />
    </ div>
  );
}
